import dayjs from 'dayjs'
import { MessageMemo } from 'src/models/MessageMemo'
import useSWR from 'swr'
import { IterableElement } from 'type-fest'
import { ApiClient } from './client'
import {
  DELETE_COMPANY_GROUP_MEMOS,
  POST_COMPANY_GROUP_MEMOS,
} from './endpoints'
import {
  CreateMessageGroupMemoRequest,
  DeleteMessageGroupMemoRequest,
  MessageGroupMemosResponse,
} from './types/messageGroupMemo'

const messageGroupMemoFetcher = async (url: string, _: any) => {
  if (!url) return []
  const res = await ApiClient.get<{ memos: MessageGroupMemosResponse }>(url)
  return res.data?.memos ? res.data?.memos.map(toMessageGroupMemo) : []
}

export const useMessageGroupMemos = (url: string) =>
  useSWR(url, messageGroupMemoFetcher)

export const toMessageGroupMemo = (
  memo: IterableElement<MessageGroupMemosResponse>,
): MessageMemo => ({
  id: memo.id,
  roomId: memo.companyMessageGroupRoomId,
  companyId: memo.companyId,
  content: memo.content,
  createdAt: dayjs(memo.createdAt),
})

export const createMessageGroupMemo = async (
  companyMessageGroupRoomId: number,
  content: string,
) => {
  const body: CreateMessageGroupMemoRequest = {
    company_message_group_room_id: companyMessageGroupRoomId,
    content: content,
  }
  return ApiClient.post(POST_COMPANY_GROUP_MEMOS, body)
}

export const deleteMessageGroupMemo = async (
  id: number,
  companyMessageGroupRoomId: number,
) => {
  const body: DeleteMessageGroupMemoRequest = {
    id: id,
    company_message_group_room_id: companyMessageGroupRoomId,
  }
  return ApiClient.post(DELETE_COMPANY_GROUP_MEMOS, body)
}
